export  const OTP_TRANS_LIMIT_BETA_NAME ="otpTransactionLimit"
export const OTP_TEXT={
    "OTP_LIMIT_VALIDATION_TEXT":"OTP_LIMIT_VALIDATION_TEXT"
}